import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from "reactstrap";
import { salesDeveloperPrefix } from "configs/routePrefix";
import { Stepper } from 'react-form-stepper';
import CompoundForm from "../CompoundForm"
import BuildingForm from "../BuildingForm"
import PropertyForm from "../PropertyForm"
import CancelModal from "components/CancelModal"
import Summary from "../Summary"
import { useSelector } from "react-redux";

const CompoundPage = (props) => {
    const [formStep, setFormStep] = useState(0);
    const [compoundId, setCompoundId] = useState();
    const [BuildingId, setBuildingId] = useState();
    const [BuildingData, setBuildingData] = useState([])
    const [compoundData, setCompoundData] = useState([])
    const [propertyData, setPropertyData] = useState([]);
    const [modal, setModal] = useState(false)
    const filterData = useSelector(state=> state.adminFilter)

    const updateBulidingList = (id, data) => {
        if (id) {
            setBuildingData(oldData => {
                const updatedData = oldData.map(item => {
                    if (item.id == id) {
                        return {
                            ...item,
                            ...data
                        }
                    } else {
                        return item
                    }
                })
                return [...updatedData]
            })
        } else {
            setBuildingData(oldData => {
                return [...oldData, data]
            })
        }
    }
    const deleteBuilding = (id) => {
        setBuildingData(data => {
            const filttered = data.filter(item => item.id != id)
            return [...filttered]
        })
    }
    const updatePropertyList = (id, data) => {
        if (id) {
            setPropertyData(oldData => {
                const updatedData = oldData.map(item => {
                    if (item.id == id) {
                        return {
                            ...item,
                            ...data
                        }
                    } else {
                        return item
                    }

                })
                return [...updatedData]
            })
        } else {
            setPropertyData(oldData => {
                return [...oldData, data]
            })
        }
    }
    const deleteProperty = (id) => {
        setPropertyData(data => {
            const filttered = data.filter(item => item.id != id)
            return [...filttered]
        })
    }
    const nextFormStep = (step) => {
        if (step === 0) {
            setFormStep(step)
        } else if (step) {
            setFormStep(step)
        }
        else {
            setFormStep(formStep + 1)
        }
       
    };
    // useEffect(() => {
    //     // template string inside query Selectpor
    //    const element=  document.querySelector(`.RFS-Label-d1`)
    //  if(element){
    //     element.style.fontWeight="700"
    //  }


    // }, [])
    useEffect(() => {
        // template string inside query Selectpor 
        const value=2*formStep+1
      const element=  document.querySelector(`.RFS-Label-d${value}`)
      if(element){
        element.style.fontWeight="700"
     }
    }, [formStep])

    const lastFormStep = () => {
        setFormStep(formStep - 1);
    };

    const renderButton = () => {
        if (formStep > 3) {
            return undefined;
        } else if (formStep === 0) {
            return (
                <Col md={6} className="d-flex flex-row-reverse">
                    <button type="submit" className="btn btn-success btnHeight w-25  ">Continue</button>
                </Col>
            );
        }
    };
    const ButtonCard = () => {
        return (
            <Row className="my-2">
                <Card>
                    <CardBody>
                        <Row className="d-flex flex-row-reverse">
                            {renderButton()}
                        </Row>
                    </CardBody>
                </Card >
            </Row>
        )
    }
    const submitForm = () => {
        props.history.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)
    }
    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Compounds</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mx-4">
                        <h4>{(formStep === 1 || formStep === 2) && <button className="p-0 m-0 border-0 bg-light"
                            onClick={() =>setModal(true)}>
                            <i className="fa fa-arrow-left text-primary me-2"></i>
                        </button>}
                            Add New Compound</h4>
                        <p>Follow the following steps and add the required info. to add compound</p>
                    </Row>
                    <Row className="position-relative" >
                        <div style={{ width: "4.5%", height: "0.4em", position: "absolute", top: "30%", left: "7%", background: "#556ee6", }}></div>
                        <Stepper
                            steps={[
                                { label: "Compound Information" },
                                { label: "Building Setup" },
                                { label: "Properties Setup" },
                                { label: "Summary" },
                            ]}
                            // className="mx-0 px-0 py-2"
                            connectorStateColors={true}
                            styleConfig={{
                                activeBgColor: 'white',
                                activeTextColor: '#495057',
                                inactiveBgColor: '#FFFFFF',
                                inactiveTextColor: '#495057',
                                completedBgColor: '#FFFFFF',
                                completedTextColor: '#495057',
                                size: '3em',

                            }}
                            // stepClassName="font-weight-bold"
                            connectorStyleConfig={{
                                size: '.4em',
                                completedColor: '#556ee6',
                                activeColor: '#556ee6',
                                disabledColor: "#f8f8fb",
                                disabledColor: "#f6f6f6"
                            }}

                            className={'stepper'}
                            stepClassName={'stepper__step'}
                            activeStep={formStep}
                        />
                        {formStep===3 && 
                         <div style={{ width: "3.5%", height: "0.4em", position: "absolute", top: "30%", right: "7.7%", background: "#556ee6", }}></div>

                        }
                    </Row>
                    {formStep === 0 &&
                        <CompoundForm
                            history={props.history}
                            nextFormStep={nextFormStep}
                            setCompoundId={setCompoundId}
                            id={compoundId}
                            setCompoundData={setCompoundData}
                            compoundData={compoundData}
                        >
                            <ButtonCard />
                        </CompoundForm>
                    }
                    {formStep === 1 &&

                        <BuildingForm
                            compoundId={compoundId}
                            id={BuildingId}
                            setBuildingId={setBuildingId}
                            nextFormStep={nextFormStep}
                            setBuildingData={setBuildingData}
                            BuildingData={BuildingData}
                            updateBulidingList={updateBulidingList}
                            deleteBuilding={deleteBuilding}
                            history={props.history}
                            propertyData={propertyData}
                        />

                    }
                    {formStep === 2 &&
                        <PropertyForm
                        // compoundId={compoundId}
                            history={props.history}
                            compoundId={compoundId}
                            nextFormStep={nextFormStep}
                            setPropertyData={setPropertyData}
                            propertyData={propertyData}
                            updatePropertyList={updatePropertyList}
                            deleteProperty={deleteProperty}
                            BuildingData={BuildingData}
                        />
                    }
                    {formStep === 3 &&
                       <Summary
                       nextFormStep={nextFormStep}
                       compoundData={compoundData}
                       BuildingData={BuildingData}
                       propertyData={propertyData}
                       submitForm={submitForm}
                       compoundId={compoundId}
                       setCompoundData={setCompoundData}

                   >
                       <ButtonCard />
                   </Summary>}
                    <CancelModal modal={modal}
                        setModal={setModal}
                        goBackHandler={() => {
                            setModal(false)
                            lastFormStep()
                        }}
                    />
                </Container>
            </div>
        </>
    )
}

export default CompoundPage